import { Box, SvgIcon } from '@mui/material';

import { minorTextGrey } from '@/theme';

export type SensorIconProps =
    | {
          color?: string;
          Icon: typeof SvgIcon;
          src?: never;
      }
    | {
          color?: string;
          Icon?: never;
          src: string;
      };

export const SensorIcon = ({ Icon, src, color = minorTextGrey }: SensorIconProps) => (
    <>
        {Icon && <Icon htmlColor={color} />}
        {src && (
            <Box
                style={{
                    height: '1em',
                    width: '1em',
                    fontSize: '1.5rem',
                    backgroundColor: color,
                    mask: `url("${src}") no-repeat center`,
                }}
            />
        )}
    </>
);
